import actionTypes from '../actionTypes';

const notificationInitial = { message: '', appearance: 'success' };
export const notification = ( state = notificationInitial, action ) => {
    switch (action.type) {
        case actionTypes.SHOW_NOTIFICATION:
            return { message: action.message, appearance: action.appearance || 'success' };
        case actionTypes.RESET_NOTIFICATION:
            return notificationInitial;
        default:
            return state
    }
};
